// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 620 ? "pdfjsWorker" : chunkId) + "." + {"127":"e64a89980b24c2adba05","297":"fa05eba46b657dcca5c1","620":"282f1806a37c9957f8f0"}[chunkId] + ".js";
};